import { findDictList } from '@/service/api';
import { IDictItem, IDictState } from "@/typings/dict";
import { Module } from "vuex";
import { IGlobalState } from "..";
import * as Types from '../action-types';

const state: IDictState = {
    curDictCode: '',
    curDictName: '',
    dicts: [],
};

const dict: Module<IDictState, IGlobalState> = {
    namespaced: true,
    state,
    mutations: {
        [Types.SET_DICT_LIST](state, payload: IDictItem[]) {
            state.dicts = payload;
        },
        [Types.SET_CUR_DICT](state, payload: IDictItem) {
            state.curDictCode = payload.dict_code;
            state.curDictName = payload.dict_name;
        }
    },
    actions: {
        // 设置字典列表
        async [Types.SET_DICT_LIST]({ commit }, params) {
            let result = await findDictList(params);
            commit(Types.SET_DICT_LIST, result.data.rows);
        }
    }
};
export default dict;